import api from "./api";

// Device/browser labels shared by page-view and install-event tracking.
export function detectDevice() {
  const ua = navigator.userAgent;
  if (/tablet|ipad/i.test(ua)) return "tablet";
  if (/mobile|iphone|android.*mobile/i.test(ua)) return "mobile";
  return "desktop";
}

export function detectBrowser() {
  const ua = navigator.userAgent;
  if (ua.includes("Firefox")) return "Firefox";
  if (ua.includes("Edg")) return "Edge";
  if (ua.includes("Chrome") && !ua.includes("Edg")) return "Chrome";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
  if (ua.includes("Opera") || ua.includes("OPR")) return "Opera";
  return "Other";
}

// "app" when running as the installed PWA (standalone window), else "browser".
export function appMode() {
  if (typeof window === "undefined") return "browser";
  const standalone =
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true; // iOS home-screen app
  return standalone ? "app" : "browser";
}

// Report one install-funnel event for the Admin analytics tab. Cookie-free like page
// views; never throws — tracking must not break the app.
export function trackPwaEvent(event) {
  api.post("/api/analytics/event", {
    event,
    pagePath: window.location.pathname,
    userAgent: navigator.userAgent,
    device: detectDevice(),
    browser: detectBrowser(),
    appMode: appMode(),
  }).catch(() => {});
}
